import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getAward } from "store/actions/award";
import { awardSelectors } from "store/selectors";
import SubHeader from "@cayuse/shared-react.components.sub-header";
import { isNonEmptyArray, isNumber } from "@cayuse/shared-react.utils.type-checks";
import { useDictionary } from "hooks";
import DistributionTable from "./DistributionTable/DistributionTable";
import AccountDistributionTable from "./AccountDistributionTable/AccountDistributionTable";
import styles from "./styles.css";

const OBLIGATED_AMOUNT_COLUMN_HEADER = "Obligated Amount";
const TOTA_EXPECTED_AMOUNT_COLUMN_HEADER = "Total Expected Amount";

const INITIAL_VALUES = {
	obligatedAmount: 0,
	expectedAmount: 0,
	distributedAmount: 0
};
const AccountDistribution = () => {
	const award = useSelector(awardSelectors.award);
	const { awardId } = useParams();
	const { data: awardValues } = useSelector(awardSelectors.values);
	const distributions = award?.distributions;
	const [ obligatedAmount, setObligatedAmount ] = useState(INITIAL_VALUES.obligatedAmount);
	const [ expectedAmount, setExpectedAmount ] = useState(INITIAL_VALUES.expectedAmount);
	const [ totalDistributed,  setTotalDistributed ] = useState(INITIAL_VALUES.distributedAmount);
	const dictionary = useDictionary("awards.distributionTable");

	const onDistributionSave = ()=>{
		getAward(awardId, { isRefresh: true });
	};

	useEffect(() => {
		const fetchData = async () => {
			await getAward(awardId, { isRefresh: false });
		};

		if(!award.awardId) {
			fetchData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ awardId ]);

	useEffect(()=>{
		if(award.formElements) {
			const obligatedAmount = award.formElements.find( element =>{
				return element.columnHeader === OBLIGATED_AMOUNT_COLUMN_HEADER;
			});
			if(obligatedAmount) {
				setObligatedAmount(parseInt(awardValues[obligatedAmount.id], 10));
			}

			const expectedAmount = award.formElements.find( element =>{
				return element.columnHeader === TOTA_EXPECTED_AMOUNT_COLUMN_HEADER;
			});
			if(expectedAmount) {
				setExpectedAmount(parseInt(awardValues[expectedAmount.id]));
			}
			if(isNonEmptyArray(distributions)) {
				const accountsDistributedValues = distributions.map(distribution => {
					if(isNumber(distribution.amount)) {
						return distribution.amount;
					}else{
						return INITIAL_VALUES.distributedAmount;
					}
				});
				setTotalDistributed(accountsDistributedValues.reduce((accumulator, currentValue) => accumulator + currentValue));
			} else {
				setTotalDistributed(INITIAL_VALUES.distributedAmount);
			}
		}
	}, [ award, awardValues, distributions ] );

	return(
		<>
			<SubHeader className={styles.heading}>{dictionary.title ?? "Funds & Distribution Summary"}</SubHeader>
			<div className={styles.tablesContainer}>
				<div className={styles.tables}>
					<DistributionTable totalExpected={expectedAmount} obligated={obligatedAmount} distributed={totalDistributed}></DistributionTable>
				</div>
				<div className={styles.tables}>
					<AccountDistributionTable award={award} distributions={distributions} notifyParentOnSave={onDistributionSave}/>
				</div>
			</div>
		</>
	);
};

export default AccountDistribution;
